import { render, staticRenderFns } from "./ClassroomSignature.vue?vue&type=template&id=4a9d2bd4&scoped=true"
import script from "./ClassroomSignature.vue?vue&type=script&lang=js"
export * from "./ClassroomSignature.vue?vue&type=script&lang=js"
import style0 from "./ClassroomSignature.vue?vue&type=style&index=0&id=4a9d2bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9d2bd4",
  null
  
)

export default component.exports